import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className: string;
}

export const MainLayoutDesktop = styled.div<IProps>`
  #container {
    min-height: calc(100vh - 120px);
  }

  .inner-float-utils {
    position: fixed;
    right: 40px;
    bottom: 40px;
    z-index: 100;
  }

  &.for-you-curation-page {
    &:has(.for-you-curation-template .corner-style-pick) {
      #container {
        min-height: auto;
      }

      #footer {
        margin-top: 98px;
      }
    }

    &:not(:has(.for-you-curation-template .category-menubar)) {
      .title-cont-desktop {
        padding-bottom: 60px;
      }
    }
  }

  &.event-mainLayoutDesktop {
    .title-cont-desktop {
      padding: 40px 0 16px;

      .title {
        ${mixin.flex({})};
      }

      .text {
        font-family: ${({ theme }) => theme.fontFamily.thin};
        font-weight: 300;
        line-height: 44px;
        font-size: 44px;
      }
    }

    .location {
      ${mixin.flex({})};
      gap: 0 15px;
      padding-bottom: 36px;
      border-bottom: 1px solid #eaeaea;

      li {
        position: relative;
        font-size: 11px;

        &:after {
          content: '';
          display: block;
        }

        svg {
          position: absolute;
          top: 50%;
          right: -8px;
          margin-top: -2px;
        }

        a {
          color: #676767;
        }
      }
    }

    .event-info {
      max-width: 1902px;
      height: 99px;
      ${mixin.flex({ justify: 'flex-end', align: 'center' })}
      gap: 0 20px;
      padding: 0 60px;
      margin: 0 auto;

      .text {
        flex: 1;
      }

      .share-btn-wrap {
        ${mixin.flex({})};
        gap: 0 8px;
      }
    }

    .view-product-btn {
      position: fixed;
      bottom: 40px;
      left: 0;
      right: 0;
      margin: 0 auto;
      z-index: 99;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease 0s, visibility 0.3s ease 0s;

      &.active {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    &.mega-promotion-page {
      .share-btn-wrap {
        display: flex;
        column-gap: 12px;
      }
    }

    &.myheart-page {
      .title-cont-desktop {
        padding: 72px 0 20px 0;
      }
    }

    &.attend-event .event-info {
      border-bottom: 1px solid #eaeaea;
    }
  }
`;
